/* tslint:disable */
/* eslint-disable */
/**
 * PID Backoffice Gateway - Events
 * BackOffice to manage integrations to pid-backoffice-events service.
 *
 * The version of the OpenAPI document: 6.0
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * List of applications where the event has been carried out.
 * @export
 * @enum {string}
 */

export const ApplicationV7x0 = {
    BACKOFFICE: 'BACKOFFICE',
    MOBILE_APPLICATION: 'MOBILE_APPLICATION',
    UNKNOWN: 'UNKNOWN'
} as const;

export type ApplicationV7x0 = typeof ApplicationV7x0[keyof typeof ApplicationV7x0];


/**
 * 
 * @export
 * @interface DecoratedEventDtoV6
 */
export interface DecoratedEventDtoV6 {
    /**
     * 
     * @type {EventCategoryResponseV7x0}
     * @memberof DecoratedEventDtoV6
     */
    'eventCategory': EventCategoryResponseV7x0;
    /**
     * 
     * @type {EventTypeResponseV7x0}
     * @memberof DecoratedEventDtoV6
     */
    'eventType': EventTypeResponseV7x0;
    /**
     * 
     * @type {ApplicationV7x0}
     * @memberof DecoratedEventDtoV6
     */
    'application'?: ApplicationV7x0;
    /**
     * 
     * @type {UserTypeV7x0}
     * @memberof DecoratedEventDtoV6
     */
    'initiatorUserType': UserTypeV7x0;
    /**
     * 
     * @type {string}
     * @memberof DecoratedEventDtoV6
     */
    'timestamp': string;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof DecoratedEventDtoV6
     */
    'initiatorPidUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof DecoratedEventDtoV6
     */
    'initiatorUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DecoratedEventDtoV6
     */
    'initiatorAdvisorId'?: number;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof DecoratedEventDtoV6
     */
    'affectedClientPidUuid'?: string;
    /**
     * Universally Unique Identifier.
     * @type {string}
     * @memberof DecoratedEventDtoV6
     */
    'processUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DecoratedEventDtoV6
     */
    'processService'?: string;
    /**
     * 
     * @type {object}
     * @memberof DecoratedEventDtoV6
     */
    'data'?: object;
    /**
     * 
     * @type {string}
     * @memberof DecoratedEventDtoV6
     */
    'initiatorFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DecoratedEventDtoV6
     */
    'affectedClientFullName'?: string;
}


/**
 * 
 * @export
 * @interface DecoratedEventDtoV6AllOf
 */
export interface DecoratedEventDtoV6AllOf {
    /**
     * 
     * @type {string}
     * @memberof DecoratedEventDtoV6AllOf
     */
    'initiatorFullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DecoratedEventDtoV6AllOf
     */
    'affectedClientFullName'?: string;
}
/**
 * List of categories. Each category consists of several event types (eventType). 
 * @export
 * @enum {string}
 */

export const EventCategoryRequestV7x0 = {
    CLIENT: 'CLIENT',
    INTERNAL_APPLICATION: 'INTERNAL_APPLICATION',
    MOBILE_APPLICATION: 'MOBILE_APPLICATION',
    COMMUNICATION: 'COMMUNICATION',
    BANK_TRANSACTIONS: 'BANK_TRANSACTIONS',
    BANK_CARDS: 'BANK_CARDS',
    BANK_DOCUMENTS: 'BANK_DOCUMENTS'
} as const;

export type EventCategoryRequestV7x0 = typeof EventCategoryRequestV7x0[keyof typeof EventCategoryRequestV7x0];


/**
 * All values from EventCategoryRequest + UNKNOWN
 * @export
 * @enum {string}
 */

export const EventCategoryResponseV7x0 = {
    CLIENT: 'CLIENT',
    INTERNAL_APPLICATION: 'INTERNAL_APPLICATION',
    MOBILE_APPLICATION: 'MOBILE_APPLICATION',
    COMMUNICATION: 'COMMUNICATION',
    BANK_TRANSACTIONS: 'BANK_TRANSACTIONS',
    BANK_CARDS: 'BANK_CARDS',
    BANK_DOCUMENTS: 'BANK_DOCUMENTS',
    UNKNOWN: 'UNKNOWN'
} as const;

export type EventCategoryResponseV7x0 = typeof EventCategoryResponseV7x0[keyof typeof EventCategoryResponseV7x0];


/**
 * 
 * @export
 * @interface EventDtoV7x0
 */
export interface EventDtoV7x0 {
    /**
     * 
     * @type {EventCategoryResponseV7x0}
     * @memberof EventDtoV7x0
     */
    'eventCategory': EventCategoryResponseV7x0;
    /**
     * 
     * @type {EventTypeResponseV7x0}
     * @memberof EventDtoV7x0
     */
    'eventType': EventTypeResponseV7x0;
    /**
     * 
     * @type {ApplicationV7x0}
     * @memberof EventDtoV7x0
     */
    'application'?: ApplicationV7x0;
    /**
     * 
     * @type {UserTypeV7x0}
     * @memberof EventDtoV7x0
     */
    'initiatorUserType': UserTypeV7x0;
    /**
     * 
     * @type {string}
     * @memberof EventDtoV7x0
     */
    'timestamp': string;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof EventDtoV7x0
     */
    'initiatorPidUuid'?: string;
    /**
     * 
     * @type {number}
     * @memberof EventDtoV7x0
     */
    'initiatorUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EventDtoV7x0
     */
    'initiatorAdvisorId'?: number;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof EventDtoV7x0
     */
    'affectedClientPidUuid'?: string;
    /**
     * Universally Unique Identifier.
     * @type {string}
     * @memberof EventDtoV7x0
     */
    'processUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventDtoV7x0
     */
    'processService'?: string;
    /**
     * 
     * @type {object}
     * @memberof EventDtoV7x0
     */
    'data'?: object;
}


/**
 * 
 * @export
 * @interface EventSortV7x0
 */
export interface EventSortV7x0 {
    /**
     * 
     * @type {SortAttributeV7x0}
     * @memberof EventSortV7x0
     */
    'name': SortAttributeV7x0;
    /**
     * 
     * @type {SortTypeV7x0}
     * @memberof EventSortV7x0
     */
    'order': SortTypeV7x0;
}


/**
 * List of event types that can be logged. Each event type belongs to a category (eventCategory) 
 * @export
 * @enum {string}
 */

export const EventTypeRequestV7x0 = {
    ADDRESS_CHANGED: 'ADDRESS_CHANGED',
    ADDRESS_CHANGE_FAILED: 'ADDRESS_CHANGE_FAILED',
    APP_ACTIVATION_CANCELLED: 'APP_ACTIVATION_CANCELLED',
    APP_ACTIVATION_COMPLETED: 'APP_ACTIVATION_COMPLETED',
    APP_ACTIVATION_FAILED: 'APP_ACTIVATION_FAILED',
    APP_ACTIVATION_INITIATED: 'APP_ACTIVATION_INITIATED',
    APP_ACTIVATION_MANUALLY_VERIFIED: 'APP_ACTIVATION_MANUALLY_VERIFIED',
    APP_ACTIVATION_STEP_COMPLETED: 'APP_ACTIVATION_STEP_COMPLETED',
    CLIENT_ANALYSIS_CREATION_IN_PFS_COMPLETED: 'CLIENT_ANALYSIS_CREATION_IN_PFS_COMPLETED',
    CLIENT_ANALYSIS_CREATION_IN_PFS_FAILED: 'CLIENT_ANALYSIS_CREATION_IN_PFS_FAILED',
    CLIENT_DATA_HISTORY_SHOWN: 'CLIENT_DATA_HISTORY_SHOWN',
    CLIENT_DATA_HISTORY_SHOW_FAILED: 'CLIENT_DATA_HISTORY_SHOW_FAILED',
    CLIENT_DATA_SHOWN: 'CLIENT_DATA_SHOWN',
    CLIENT_DATA_SHOW_FAILED: 'CLIENT_DATA_SHOW_FAILED',
    CLIENT_LOGGED_IN: 'CLIENT_LOGGED_IN',
    CLIENT_LOGIN_FAILED: 'CLIENT_LOGIN_FAILED',
    CLIENT_LOGGED_OUT: 'CLIENT_LOGGED_OUT',
    CLIENT_LOGOUT_FAILED: 'CLIENT_LOGOUT_FAILED',
    CONSENT_CHANGED: 'CONSENT_CHANGED',
    CONSENT_CHANGE_FAILED: 'CONSENT_CHANGE_FAILED',
    DEVICE_ACTIVATED: 'DEVICE_ACTIVATED',
    DEVICE_ACTIVATION_FAILED: 'DEVICE_ACTIVATION_FAILED',
    DEVICE_BLOCKED: 'DEVICE_BLOCKED',
    DEVICE_BLOCKING_FAILED: 'DEVICE_BLOCKING_FAILED',
    DEVICE_REMOVED: 'DEVICE_REMOVED',
    DEVICE_REMOVAL_FAILED: 'DEVICE_REMOVAL_FAILED',
    DEVICE_TEMPORARILY_BLOCKED: 'DEVICE_TEMPORARILY_BLOCKED',
    DEVICE_TEMPORARY_BLOCKING_FAILED: 'DEVICE_TEMPORARY_BLOCKING_FAILED',
    DEVICE_UNBLOCKED: 'DEVICE_UNBLOCKED',
    DEVICE_UNBLOCKING_FAILED: 'DEVICE_UNBLOCKING_FAILED',
    EMAIL_CHANGED: 'EMAIL_CHANGED',
    EMAIL_CHANGE_FAILED: 'EMAIL_CHANGE_FAILED',
    PHONE_CHANGED: 'PHONE_CHANGED',
    PHONE_CHANGE_FAILED: 'PHONE_CHANGE_FAILED',
    PFS_ADVISOR_ROLE_SET_CHANGED: 'PFS_ADVISOR_ROLE_SET_CHANGED',
    PFS_ADVISOR_ROLE_SET_CHANGE_FAILED: 'PFS_ADVISOR_ROLE_SET_CHANGE_FAILED',
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    USER_LOGIN_FAILED: 'USER_LOGIN_FAILED',
    USER_LOGGED_OUT: 'USER_LOGGED_OUT',
    USER_LOGOUT_FAILED: 'USER_LOGOUT_FAILED',
    NOTIFICATION_SENT: 'NOTIFICATION_SENT',
    NOTIFICATION_FAILED: 'NOTIFICATION_FAILED',
    SMS_SENT: 'SMS_SENT',
    SMS_FAILED: 'SMS_FAILED',
    EMAIL_SENT: 'EMAIL_SENT',
    EMAIL_FAILED: 'EMAIL_FAILED',
    CALL: 'CALL',
    CALL_FAILED: 'CALL_FAILED',
    MA_CHAT: 'MA_CHAT',
    MA_CHAT_FAILED: 'MA_CHAT_FAILED',
    CLIENT_DOCUMENTATION_SEND_TO_PFS_COMPLETED: 'CLIENT_DOCUMENTATION_SEND_TO_PFS_COMPLETED',
    CLIENT_DOCUMENTATION_SEND_TO_PFS_FAILED: 'CLIENT_DOCUMENTATION_SEND_TO_PFS_FAILED'
} as const;

export type EventTypeRequestV7x0 = typeof EventTypeRequestV7x0[keyof typeof EventTypeRequestV7x0];


/**
 * All values from EventTypeRequest + UNKNOWN
 * @export
 * @enum {string}
 */

export const EventTypeResponseV7x0 = {
    ADDRESS_CHANGED: 'ADDRESS_CHANGED',
    ADDRESS_CHANGE_FAILED: 'ADDRESS_CHANGE_FAILED',
    APP_ACTIVATION_CANCELLED: 'APP_ACTIVATION_CANCELLED',
    APP_ACTIVATION_COMPLETED: 'APP_ACTIVATION_COMPLETED',
    APP_ACTIVATION_FAILED: 'APP_ACTIVATION_FAILED',
    APP_ACTIVATION_INITIATED: 'APP_ACTIVATION_INITIATED',
    APP_ACTIVATION_MANUALLY_VERIFIED: 'APP_ACTIVATION_MANUALLY_VERIFIED',
    APP_ACTIVATION_STEP_COMPLETED: 'APP_ACTIVATION_STEP_COMPLETED',
    CLIENT_ANALYSIS_CREATION_IN_PFS_COMPLETED: 'CLIENT_ANALYSIS_CREATION_IN_PFS_COMPLETED',
    CLIENT_ANALYSIS_CREATION_IN_PFS_FAILED: 'CLIENT_ANALYSIS_CREATION_IN_PFS_FAILED',
    CLIENT_DATA_HISTORY_SHOWN: 'CLIENT_DATA_HISTORY_SHOWN',
    CLIENT_DATA_HISTORY_SHOW_FAILED: 'CLIENT_DATA_HISTORY_SHOW_FAILED',
    CLIENT_DATA_SHOWN: 'CLIENT_DATA_SHOWN',
    CLIENT_DATA_SHOW_FAILED: 'CLIENT_DATA_SHOW_FAILED',
    CLIENT_LOGGED_IN: 'CLIENT_LOGGED_IN',
    CLIENT_LOGIN_FAILED: 'CLIENT_LOGIN_FAILED',
    CLIENT_LOGGED_OUT: 'CLIENT_LOGGED_OUT',
    CLIENT_LOGOUT_FAILED: 'CLIENT_LOGOUT_FAILED',
    CONSENT_CHANGED: 'CONSENT_CHANGED',
    CONSENT_CHANGE_FAILED: 'CONSENT_CHANGE_FAILED',
    DEVICE_ACTIVATED: 'DEVICE_ACTIVATED',
    DEVICE_ACTIVATION_FAILED: 'DEVICE_ACTIVATION_FAILED',
    DEVICE_BLOCKED: 'DEVICE_BLOCKED',
    DEVICE_BLOCKING_FAILED: 'DEVICE_BLOCKING_FAILED',
    DEVICE_REMOVED: 'DEVICE_REMOVED',
    DEVICE_REMOVAL_FAILED: 'DEVICE_REMOVAL_FAILED',
    DEVICE_TEMPORARILY_BLOCKED: 'DEVICE_TEMPORARILY_BLOCKED',
    DEVICE_TEMPORARY_BLOCKING_FAILED: 'DEVICE_TEMPORARY_BLOCKING_FAILED',
    DEVICE_UNBLOCKED: 'DEVICE_UNBLOCKED',
    DEVICE_UNBLOCKING_FAILED: 'DEVICE_UNBLOCKING_FAILED',
    EMAIL_CHANGED: 'EMAIL_CHANGED',
    EMAIL_CHANGE_FAILED: 'EMAIL_CHANGE_FAILED',
    PHONE_CHANGED: 'PHONE_CHANGED',
    PHONE_CHANGE_FAILED: 'PHONE_CHANGE_FAILED',
    PFS_ADVISOR_ROLE_SET_CHANGED: 'PFS_ADVISOR_ROLE_SET_CHANGED',
    PFS_ADVISOR_ROLE_SET_CHANGE_FAILED: 'PFS_ADVISOR_ROLE_SET_CHANGE_FAILED',
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    USER_LOGIN_FAILED: 'USER_LOGIN_FAILED',
    USER_LOGGED_OUT: 'USER_LOGGED_OUT',
    USER_LOGOUT_FAILED: 'USER_LOGOUT_FAILED',
    NOTIFICATION_SENT: 'NOTIFICATION_SENT',
    NOTIFICATION_FAILED: 'NOTIFICATION_FAILED',
    SMS_SENT: 'SMS_SENT',
    SMS_FAILED: 'SMS_FAILED',
    EMAIL_SENT: 'EMAIL_SENT',
    EMAIL_FAILED: 'EMAIL_FAILED',
    CALL: 'CALL',
    CALL_FAILED: 'CALL_FAILED',
    MA_CHAT: 'MA_CHAT',
    MA_CHAT_FAILED: 'MA_CHAT_FAILED',
    CLIENT_DOCUMENTATION_SEND_TO_PFS_COMPLETED: 'CLIENT_DOCUMENTATION_SEND_TO_PFS_COMPLETED',
    CLIENT_DOCUMENTATION_SEND_TO_PFS_FAILED: 'CLIENT_DOCUMENTATION_SEND_TO_PFS_FAILED',
    UNKNOWN: 'UNKNOWN'
} as const;

export type EventTypeResponseV7x0 = typeof EventTypeResponseV7x0[keyof typeof EventTypeResponseV7x0];


/**
 * A pageable response with total size that might not be exact.
 * @export
 * @interface FloatingPageableResponseV6
 */
export interface FloatingPageableResponseV6 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof FloatingPageableResponseV6
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof FloatingPageableResponseV6
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof FloatingPageableResponseV6
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof FloatingPageableResponseV6
     */
    'totalSize': number;
    /**
     * Type of the total size. The total size might not be exact for performance reasons.   * `EXACT` - the total size is exact.   * `MAXIMUM` - the total size is the allowed maximum and the actual value is bigger than that. 
     * @type {string}
     * @memberof FloatingPageableResponseV6
     */
    'totalSizeType': FloatingPageableResponseV6TotalSizeTypeEnum;
}

export const FloatingPageableResponseV6TotalSizeTypeEnum = {
    EXACT: 'EXACT',
    MAXIMUM: 'MAXIMUM'
} as const;

export type FloatingPageableResponseV6TotalSizeTypeEnum = typeof FloatingPageableResponseV6TotalSizeTypeEnum[keyof typeof FloatingPageableResponseV6TotalSizeTypeEnum];

/**
 * 
 * @export
 * @interface FloatingPageableResponseV6AllOf
 */
export interface FloatingPageableResponseV6AllOf {
    /**
     * Type of the total size. The total size might not be exact for performance reasons.   * `EXACT` - the total size is exact.   * `MAXIMUM` - the total size is the allowed maximum and the actual value is bigger than that. 
     * @type {string}
     * @memberof FloatingPageableResponseV6AllOf
     */
    'totalSizeType': FloatingPageableResponseV6AllOfTotalSizeTypeEnum;
}

export const FloatingPageableResponseV6AllOfTotalSizeTypeEnum = {
    EXACT: 'EXACT',
    MAXIMUM: 'MAXIMUM'
} as const;

export type FloatingPageableResponseV6AllOfTotalSizeTypeEnum = typeof FloatingPageableResponseV6AllOfTotalSizeTypeEnum[keyof typeof FloatingPageableResponseV6AllOfTotalSizeTypeEnum];

/**
 * Initiator of event
 * @export
 * @interface InitiatorDtoV7x0
 */
export interface InitiatorDtoV7x0 {
    /**
     * 
     * @type {PidInitiatorDtoV7x0}
     * @memberof InitiatorDtoV7x0
     */
    'pid'?: PidInitiatorDtoV7x0;
    /**
     * 
     * @type {UserInitiatorDtoV7x0}
     * @memberof InitiatorDtoV7x0
     */
    'user'?: UserInitiatorDtoV7x0;
}
/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * PID identification
 * @export
 * @interface PidInitiatorDtoV7x0
 */
export interface PidInitiatorDtoV7x0 {
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof PidInitiatorDtoV7x0
     */
    'pidUuid': string;
}
/**
 * 
 * @export
 * @interface SearchEventsRequestV6
 */
export interface SearchEventsRequestV6 {
    /**
     * 
     * @type {Array<EventCategoryRequestV7x0>}
     * @memberof SearchEventsRequestV6
     */
    'categories'?: Array<EventCategoryRequestV7x0>;
    /**
     * 
     * @type {Array<EventTypeRequestV7x0>}
     * @memberof SearchEventsRequestV6
     */
    'types'?: Array<EventTypeRequestV7x0>;
    /**
     * 
     * @type {InitiatorDtoV7x0}
     * @memberof SearchEventsRequestV6
     */
    'initiator'?: InitiatorDtoV7x0;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof SearchEventsRequestV6
     */
    'affectedPidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchEventsRequestV6
     */
    'dateFromInclusive'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchEventsRequestV6
     */
    'dateToExclusive'?: string;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof SearchEventsRequestV6
     */
    'pageable'?: PageableV1x0;
    /**
     * 
     * @type {EventSortV7x0}
     * @memberof SearchEventsRequestV6
     */
    'sort'?: EventSortV7x0;
}
/**
 * 
 * @export
 * @interface SearchEventsResponseV6
 */
export interface SearchEventsResponseV6 {
    /**
     * 
     * @type {Array<DecoratedEventDtoV6>}
     * @memberof SearchEventsResponseV6
     */
    'events'?: Array<DecoratedEventDtoV6>;
    /**
     * 
     * @type {FloatingPageableResponseV6}
     * @memberof SearchEventsResponseV6
     */
    'pageable'?: FloatingPageableResponseV6;
}
/**
 * Names of attributes that can be used for sorting
 * @export
 * @enum {string}
 */

export const SortAttributeV7x0 = {
    EVENT_CATEGORY: 'EVENT_CATEGORY',
    EVENT_TYPE: 'EVENT_TYPE',
    APPLICATION: 'APPLICATION',
    TIMESTAMP: 'TIMESTAMP'
} as const;

export type SortAttributeV7x0 = typeof SortAttributeV7x0[keyof typeof SortAttributeV7x0];


/**
 * 
 * @export
 * @enum {string}
 */

export const SortTypeV7x0 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortTypeV7x0 = typeof SortTypeV7x0[keyof typeof SortTypeV7x0];


/**
 * User identification
 * @export
 * @interface UserInitiatorDtoV7x0
 */
export interface UserInitiatorDtoV7x0 {
    /**
     * The general ID of a person
     * @type {number}
     * @memberof UserInitiatorDtoV7x0
     */
    'userId': number;
    /**
     * The general ID of a person
     * @type {number}
     * @memberof UserInitiatorDtoV7x0
     */
    'advisorId'?: number;
}
/**
 * Type of a user who carried out the event. The user can be identified by pidUuid (PID) or by userId (FIP) 
 * @export
 * @enum {string}
 */

export const UserTypeV7x0 = {
    FIP: 'FIP',
    PID: 'PID',
    UNKNOWN: 'UNKNOWN'
} as const;

export type UserTypeV7x0 = typeof UserTypeV7x0[keyof typeof UserTypeV7x0];




/**
 * BackofficeEventsGatewayApi - axios parameter creator
 * @export
 */
export const BackofficeEventsGatewayApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Find events relevant for particular client (pidUuid) based on search criteria. 
         * @summary Find client events
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchEventsRequestV6} searchEventsRequestV6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEventsV6: async (xCorrelationId: string, searchEventsRequestV6: SearchEventsRequestV6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchEventsV6', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'searchEventsRequestV6' is not null or undefined
            assertParamExists('searchEventsV6', 'searchEventsRequestV6', searchEventsRequestV6)
            const localVarPath = `/pid-backofficegateway-events/v6/events/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchEventsRequestV6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BackofficeEventsGatewayApi - functional programming interface
 * @export
 */
export const BackofficeEventsGatewayApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BackofficeEventsGatewayApiAxiosParamCreator(configuration)
    return {
        /**
         * Find events relevant for particular client (pidUuid) based on search criteria. 
         * @summary Find client events
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {SearchEventsRequestV6} searchEventsRequestV6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchEventsV6(xCorrelationId: string, searchEventsRequestV6: SearchEventsRequestV6, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchEventsResponseV6>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchEventsV6(xCorrelationId, searchEventsRequestV6, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BackofficeEventsGatewayApi - factory interface
 * @export
 */
export const BackofficeEventsGatewayApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BackofficeEventsGatewayApiFp(configuration)
    return {
        /**
         * Find events relevant for particular client (pidUuid) based on search criteria. 
         * @summary Find client events
         * @param {BackofficeEventsGatewayApiSearchEventsV6Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEventsV6(requestParameters: BackofficeEventsGatewayApiSearchEventsV6Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SearchEventsResponseV6> {
            return localVarFp.searchEventsV6(requestParameters.xCorrelationId, requestParameters.searchEventsRequestV6, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for searchEventsV6 operation in BackofficeEventsGatewayApi.
 * @export
 * @type BackofficeEventsGatewayApiSearchEventsV6Request
 */
export type BackofficeEventsGatewayApiSearchEventsV6Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof BackofficeEventsGatewayApiSearchEventsV6
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {SearchEventsRequestV6}
     * @memberof BackofficeEventsGatewayApiSearchEventsV6
     */
    readonly searchEventsRequestV6: SearchEventsRequestV6
}

/**
 * BackofficeEventsGatewayApi - object-oriented interface
 * @export
 * @class BackofficeEventsGatewayApi
 * @extends {BaseAPI}
 */
export class BackofficeEventsGatewayApi extends BaseAPI {
    /**
     * Find events relevant for particular client (pidUuid) based on search criteria. 
     * @summary Find client events
     * @param {BackofficeEventsGatewayApiSearchEventsV6Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackofficeEventsGatewayApi
     */
    public searchEventsV6(requestParameters: BackofficeEventsGatewayApiSearchEventsV6Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return BackofficeEventsGatewayApiFp(this.configuration).searchEventsV6(requestParameters.xCorrelationId, requestParameters.searchEventsRequestV6, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


